import { CreatePackageRequestBody } from '../../../../features/package/packageRequestBody';
import { selectedNewPackageTitleData,  selectPackageDetailsAction,  updateNewPackageTitleData } from '../../../../features/package/packageSlice';
import { useDispatch, useSelector } from 'react-redux';
import DropdownBtn from '../../../ui/DropdownBtn';
import { statusList, statusYesNoList } from '../../../../constant/default';
import { useState } from 'react';

interface NewPackageDetailsProps{
    typOfAction: "newPackage" | "updatePackage"
}

export default function NewPackageDetails({ typOfAction }: NewPackageDetailsProps) {

    const dispatch = useDispatch()
    const newPackageTitleData = useSelector(selectedNewPackageTitleData);
    const isUpdateAction = typOfAction === 'updatePackage';
    const packageDetailAction = useSelector(selectPackageDetailsAction);
    const isPackageCupBase = packageDetailAction.packageType === 'special'
    const isNotShowCups = isUpdateAction && isPackageCupBase;
    const newPackageName = newPackageTitleData.packageName ?? '';
    const newPackageCup = newPackageTitleData.quantity;
    const newPackageAmount = newPackageTitleData.totalValue;
    const disCountPercent = newPackageTitleData.discountPercentage ?? 0;
    const canExceed = newPackageTitleData.canExceed
    const totalCupsValue = newPackageCup  === null || newPackageCup === 0 ? '' : newPackageCup.toString()
    const discountPercentage = disCountPercent  === null || disCountPercent === 0 ? '' : disCountPercent.toString()
    const totalAmountValue = newPackageAmount === null || newPackageAmount === 0 ? '' : newPackageAmount.toString()
    const [isShow, setIsShow] = useState<boolean>(false)

    const handleChange = (typUpdate: keyof CreatePackageRequestBody, value: string | boolean) => {
        if(typUpdate === 'quantity' || typUpdate === 'totalValue' || typUpdate === 'discountPercentage') {
            const formatValueNumber = Number(value)
            dispatch(updateNewPackageTitleData({ [typUpdate]: formatValueNumber }));
        } else if (typUpdate === "canExceed") {
        dispatch(
            updateNewPackageTitleData({
                [typUpdate]: Boolean(value),
            })
        );
    } else {
            dispatch(updateNewPackageTitleData({ [typUpdate]: value }));
        }
    }

    const canExceedLabel = canExceed == undefined ? 'Select' : canExceed === true ? 'Yes' : canExceed === false ? 'No' : ''

    return (
        <div>
            <div className={`grid gap-3 ${isNotShowCups ? 'grid-cols-7' : 'grid-cols-2'}`}>
                <div className={`${isNotShowCups ? 'col-span-3' : ''}`}>
                    <label className='block text-xs font-medium text-gray-700 mb-1.5'>
                        Package Name *
                    </label>
                    <input 
                        type={'text'}
                        value={newPackageName}
                        onChange={(e) => handleChange('packageName', e.target.value)}
                        className={`block w-full text-xs rounded border border-gray-300 px-2 py-1 shadow-sm outline-none placeholder:text-gray-400 focus:border-black`}
                    />
                </div>
                {isNotShowCups && (
                    <div className={`col-span-3 grid grid-cols-2 gap-2`}>
                        <div className=''>
                            <label className='block text-xs font-medium text-gray-700 mb-1.5'>
                                {`Discount(%) *`}
                            </label>
                            <input
                                type={'number'}
                                value={discountPercentage}
                                onChange={(e) => handleChange('discountPercentage', e.target.value)}
                                className={`block w-full text-xs rounded border border-gray-300 px-2 py-1 shadow-sm outline-none placeholder:text-gray-400 focus:border-black`}
                                required
                            />
                        </div>
                        <div className=''>
                            <label className='block text-xs font-medium text-gray-700 mb-1.5'>
                                {`Exceed *`}
                            </label>
                            <div className='relative inline-block h-auto w-full'>
                                <div className='w-full h-auto'>
                                    <DropdownBtn
                                        label={canExceedLabel}
                                        isOpen={isShow}
                                        onClick={() => setIsShow(!isShow)}
                                        isCustomClass={true}
                                        customClass={'flex w-full justify-between items-center font-medium rounded transition px-2 text-black py-1 space-x-2 text-xs  border border-gray-300 outline-none placeholder:text-gray-400 focus:border-black'}
                                    />
                                    {isShow && (
                                    <ul className="absolute w-full overflow-hidden mt-1 bg-white border rounded shadow-lg z-10 border-gray-400">
                                        {statusYesNoList.map((stat) => (
                                            <li
                                                key={stat.statusId}
                                                onClick={() => {
                                                    handleChange('canExceed', stat.isActive)
                                                    setIsShow(false)
                                                }}
                                                className='px-3 py-1.5  hover:bg-gray-100 cursor-pointer text-[12px] w-full'
                                            >
                                                {stat.status}
                                            </li>
                                        ))}
                                    </ul>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                <div className={`grid ${isNotShowCups ? 'grid-cols-1' : 'grid-cols-2'} gap-3`}>
                    {!isNotShowCups && (
                        <div className=''>
                            <label className='block text-xs font-medium text-gray-700 mb-1.5'>
                                Cup *
                            </label>
                            <input
                                type={'number'}
                                value={totalCupsValue}
                                onChange={(e) => handleChange('quantity', e.target.value)}
                                className={`block w-full text-xs rounded border border-gray-300 px-2 py-1 shadow-sm outline-none placeholder:text-gray-400 focus:border-black`}
                                required
                            />
                        </div>
                    )}
                    
                    <div className=''>
                        <label className='block text-xs font-medium text-gray-700 mb-1.5'>
                            Amount *
                        </label>
                        <input 
                            type={'number'}
                            value={totalAmountValue}
                            onChange={(e) => handleChange('totalValue', e.target.value)}
                            className={`block w-full text-xs rounded border border-gray-300 px-2 py-1 shadow-sm outline-none placeholder:text-gray-400 focus:border-black`}
                            required
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}
